import { render, staticRenderFns } from "./ReservationTable.vue?vue&type=template&id=3af28ff2&scoped=true"
import script from "./ReservationTable.vue?vue&type=script&lang=js"
export * from "./ReservationTable.vue?vue&type=script&lang=js"
import style0 from "./ReservationTable.vue?vue&type=style&index=0&id=3af28ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af28ff2",
  null
  
)

export default component.exports